export { default } from './report-custom-details'
